import React, { Component } from "react";
import { withGetScreen } from "react-getscreen";
import { connect } from "react-redux";
import { getUserSaleDetailed } from "../../../../shared/requests-api";
import ItemListFidelityPlan from "./ItemListFidelityPlan";
import ItemListFidelityPlanForwardPayment from "./ItemListFidelityPlanForwardPayment";
import { isForwardPayment } from "../../helpers";


class ListFidelityPlan extends Component {
	constructor(props) {
		super(props);

		this.state = {
			modalItem: null,
			// default
			details: {
				item: {
					totalPassengers: 0,
					passengers: [],
					flights: []
				}
			},
			loading: null,
			allowChangeFlightNotify: false
		};
	}

	handerModalFn(e, itemId = null, itemStatus) {
		if (e) {
			e.preventDefault();
		}

		if (this.state.modalItem != itemId || this.state.modalItemStatus != itemStatus) {
			this.setState({
				loading: `${itemId}-${itemStatus}`
			});
			getUserSaleDetailed(undefined, itemId)
				.then(response => {
					this.setState({
						modalItem: itemId,
						modalItemStatus: itemStatus,
						details: response.data,
						loading: null,
						allowChangeFlightNotify: response.data.allowChangeFlightNotify
					});
				})
				.catch(err => {
					this.setState({
						modalItem: null,
						modalItemStatus: null,
						loading: null
					});
				});
		} else {
			this.setState({
				modalItem: null,
				modalItemStatus: null,
				loading: null
			});
		}
	}

	onConfirmChangeFlightFn = () => {
		this.setState({
			allowChangeFlightNotify: false
		});
	};

	componentDidUpdate(prevProps) {
		if (
			JSON.stringify(prevProps.sales) !== JSON.stringify(this.props.sales) &&
			this.props.sales.length === 1
		) {
			this.handerModalFn(null, this.props.sales[0].id, this.props.sales[0].status);
		}
	}

	componentDidMount() {
		if (this.props.sales.length === 1) {
			this.handerModalFn(null, this.props.sales[0].id, this.props.sales[0].status);
		}
	}

	render() {
		const items = this.props.sales.map((item, index) => {
			const UniqueComponent = isForwardPayment(item.modality, item.transaction) ? ItemListFidelityPlanForwardPayment : ItemListFidelityPlan;
			return <UniqueComponent
				key={index}
				sale={item}
				loading={`${item.id}-${item.status}` == this.state.loading}
				details={this.state.details}
				open={item.id === this.state.modalItem && item.status === this.state.modalItemStatus}
				allowChangeFlightNotify={this.state.allowChangeFlightNotify}
				onConfirm={this.onConfirmChangeFlightFn}
				click={e => this.handerModalFn(e, item.id, item.status)}
			/>
	});
		return (
			<div className="list-fidelity-plan">
				<div className="list-mode row">{items}</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	sales: state.mySales.salesData.sales
});

export default withGetScreen(connect(mapStateToProps)(ListFidelityPlan), {
	mobileLimit: 468, // TODO Fix screen vars
	tabletLimit: 768, // TODO Fix screen vars
	shouldListenOnResize: true
});
